<template>
    <div class="top-level-menu-custom-reason-item" @click="clicked">
        <div class="top-level-menu-custom-reason-item-icon small webagent_status_widget icon  away"></div>
        <div class="top-level-menu-custom-reason-item-text ellipsis">{{customReason.text}}</div>
    </div>
</template>

<script>

    export default {
        name: "top-level-menu-custom-reason-item-view",
        props: {
            customReason: {
                type: Object
            }
        },
        methods: {
            clicked() {
                this.$emit('clicked', this.customReason);
            }
        }
    }

</script>

<style scoped>

</style>
